import { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

import NLCodeContext from './ContextNLCode';

import { useNLCode } from 'api/getNLCode';
import transformKeys from './util/transformKeys';
import useCart from 'hook/useCart';

import LayoutNLCode from './LayoutNLCode';
import usePkg from 'hook/usePkg';

const currDate = new Date();

function InsuranceNLcode() {
  const { options } = usePkg();
  const { addItems } = useCart();
  // const { mutateAsync: parse_ewp } = useServiceParseEWP();
  const [activeStep, setActiveStep] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [parseData, setParseData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [nlcode, setNLCode] = useState('');
  const [policyDate, setPolicyDate] = useState(currDate);
  const [expand, setExpanded] = useState(false);
  const [pkg, setPkg] = useState(options[0]);
  const { refetch: getNLCode } = useNLCode(nlcode);

  const handleSubmit = () => {
    const newSwal = Swal.mixin({
      customClass: {
        confirmButton: 'button button-success',
        cancelButton: 'button button-error',
      },
      buttonsStyling: false,
    });

    newSwal
      .fire({
        title: 'ข้อมูลถูกต้อง?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      })
      .then((result) => {
        if (result.isConfirmed) {
          addItems(parseData);
          Swal.fire('สำเร็จ', 'เพิ่มไปที่รถเช็นแล้ว', 'success').then(() => {
            setNLCode('');
            setParseData([]);
            setDisabled(true);
            setActiveStep(0);
          });
        }
      });
  };

  const getNLCodeList = () => {
    Swal.fire({
      title: 'กำลังดำเนินการ',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        getNLCode()
          .then((data) => {
            if (data.isError) {
              throw data.error;
            }
            if (process.env.NODE_ENV !== 'production') {
              console.log(data.data);
            }
            setParseData(transformKeys(data.data, policyDate, pkg?.value));
            Swal.fire('สำเร็จ', '', 'success');
          })
          .catch((err) => {
            Swal.close();
            let errMsg = handleAxios(err);
            Swal.fire('ล้มเหลว', `${errMsg !== '' ? errMsg : err?.response}`, 'error');
          });
      },
    });
  };

  function handleSelected(data) {
    const value = data.map((d) => d.original);
    setSelectedData(value);
  }

  function handleRemove() {
    let difference = getDifference(parseData, selectedData);
    setParseData(difference);
    setSelectedData([]);
  }

  function handleRemoveAll() {
    setParseData([]);
    setSelectedData([]);
  }

  function getDifference(arr1, arr2) {
    const makeDiff = (array1, array2) =>
      array1.filter((object1) => !array2.some((object2) => object1.idCard === object2.idCard));
    return [...makeDiff(arr1, arr2), ...makeDiff(arr2, arr1)];
  }

  function handleAxios(err) {
    let errMsg;
    if (axios.isAxiosError(err)) {
      if (err.response?.data) {
        errMsg = err.response.data;
      }
    }
    return errMsg;
  }

  return (
    <NLCodeContext.Provider
      value={{
        activeStep,
        setActiveStep,
        disabled,
        setDisabled,
        handleSubmit,
        getNLCodeList,
        parseData,
        setParseData,
        selectedData,
        setSelectedData,
        nlcode,
        setNLCode,
        policyDate,
        setPolicyDate,
        expand,
        setExpanded,
        pkg,
        setPkg,
        handleSelected,
        handleRemove,
        handleRemoveAll,
      }}
    >
      <LayoutNLCode />
    </NLCodeContext.Provider>
  );
}

export default InsuranceNLcode;
